/* Copyright 2018 The MathWorks, Inc. */

define([
    "dojo/_base/declare"
], function (declare) {

    var that;

    return declare(null, {

        _preventRestoreFocus: false,
        
        postCreate: function () {
            that = this;
            this.inherited(arguments);

            this.domNode.addEventListener("restorefocus", this._handleRestoreFocus, true);
            this.own({
                remove: function () {
                    if (that && that.domNode && that._handleRestoreFocus) {
                        that.domNode.removeEventListener("restorefocus", that._handleRestoreFocus, true);
                    }
                }
            });
            
            // Since the default value is falsey we need to explicitly call the setter in postCreate
            this.set("preventRestoreFocus", this.get("preventRestoreFocus"));
        },

        _handleRestoreFocus: function (e) {
            // If the widget does not explicitly handle event prevention, then we can block it ourselves.
            if (that.get("preventRestoreFocus")) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        },

        _getPreventRestoreFocusAttr: function () {
            return this._preventRestoreFocus;
        },

        _setPreventRestoreFocusAttr: function (value) {
            if (typeof value !== "boolean") {
                throw new Error("'preventRestoreFocus' property expected a boolean value.");
            }

            this._set("_preventRestoreFocus", value);
        }
    });
});